import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/facebook.png'
import _imports_1 from '../assets/whatsapp.png'
import _imports_2 from '../assets/Instagram.png'


const _hoisted_1 = { class: "floating-contact-buttons" }
const _hoisted_2 = ["title"]
const _hoisted_3 = ["alt"]
const _hoisted_4 = ["title"]
const _hoisted_5 = ["alt"]
const _hoisted_6 = ["title"]
const _hoisted_7 = ["alt"]
const _hoisted_8 = ["title"]

import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

// 使用i18n获取翻译文本

export default /*@__PURE__*/_defineComponent({
  __name: 'FloatingContactButtons',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();

// 跳转到体验申请表单
const goToApplicationForm = () => {
  router.push('/application-form');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: "https://www.facebook.com/profile.php?id=61577205355724",
      target: "_blank",
      class: "floating-button facebook-button",
      title: _unref(t)('facebook')
    }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: _unref(t)('facebook'),
        class: "button-icon"
      }, null, 8, _hoisted_3)
    ], 8, _hoisted_2),
    _createElementVNode("a", {
      href: "whatsapp://send?phone=+85266860815",
      target: "_blank",
      class: "floating-button whatsapp-button",
      title: _unref(t)('whatsapp')
    }, [
      _createElementVNode("img", {
        src: _imports_1,
        alt: _unref(t)('whatsapp'),
        class: "button-icon"
      }, null, 8, _hoisted_5)
    ], 8, _hoisted_4),
    _createElementVNode("a", {
      href: "https://www.instagram.com/dr_moto_ev_hk_ltd/",
      target: "_blank",
      class: "floating-button instagram-button",
      title: _unref(t)('instagram')
    }, [
      _createElementVNode("img", {
        src: _imports_2,
        alt: _unref(t)('instagram'),
        class: "button-icon"
      }, null, 8, _hoisted_7)
    ], 8, _hoisted_6),
    _createElementVNode("button", {
      class: "floating-button application-button",
      title: _unref(t)('application'),
      onClick: goToApplicationForm
    }, [...(_cache[0] || (_cache[0] = [
      _createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"28\" height=\"28\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-9fe070e2><path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\" data-v-9fe070e2></path><polyline points=\"14 2 14 8 20 8\" data-v-9fe070e2></polyline><line x1=\"16\" y1=\"13\" x2=\"8\" y2=\"13\" data-v-9fe070e2></line><line x1=\"16\" y1=\"17\" x2=\"8\" y2=\"17\" data-v-9fe070e2></line><polyline points=\"10 9 9 9 8 9\" data-v-9fe070e2></polyline></svg>", 1)
    ]))], 8, _hoisted_8)
  ]))
}
}

})